
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import ExperienceSection from './components/ExperienceSection';
import SkillsSection from './components/SkillsSection';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  useEffect(() => {
    // Add Schema.org JSON-LD for Professional Service
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      "name": "Regiane Fialho - Engenharia Civil",
      "description": "Engenharia orientada a resultados em Maringá/PR: PPCP, Projetos & Obras e Segurança do Trabalho.",
      "url": import.meta.env.VITE_SITE_URL || "https://regianefialho.com.br",
      "telephone": "+55-44-99992-1632",
      "email": "contato@regianefialho.com.br",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Maringá",
        "addressRegion": "PR",
        "addressCountry": "BR"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "-23.4273",
        "longitude": "-51.9375"
      },
      "openingHours": [
        "Mo-Fr 08:00-18:00",
        "Sa 08:00-12:00"
      ],
      "serviceType": [
        "PPCP - Planejamento e Controle da Produção",
        "Projetos & Obras",
        "Segurança do Trabalho",
        "Consultoria em Engenharia Civil"
      ],
      "founder": {
        "@type": "Person",
        "name": "Regiane Fialho",
        "jobTitle": "Engenheira Civil",
        "url": import.meta.env.VITE_SITE_URL || "https://regianefialho.com.br",
        "sameAs": [
          "https://www.linkedin.com/in/regiane-f-a2a802ab",
          "https://www.instagram.com/engregianefialho/"
        ]
      },
      "areaServed": {
        "@type": "Place",
        "name": "Paraná, Brasil"
      },
      "priceRange": "$$",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "5.0",
        "reviewCount": "15"
      }
    });
    document.head.appendChild(script);

    // Add Organization Schema
    const orgScript = document.createElement('script');
    orgScript.type = 'application/ld+json';
    orgScript.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Regiane Fialho - Engenharia Civil",
      "url": import.meta.env.VITE_SITE_URL || "https://regianefialho.com.br",
      "logo": `${import.meta.env.VITE_SITE_URL || "https://regianefialho.com.br"}/logo.png`,
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+55-44-99992-1632",
        "contactType": "customer service",
        "areaServed": "BR",
        "availableLanguage": "Portuguese"
      },
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Maringá",
        "addressRegion": "PR",
        "addressCountry": "BR"
      },
      "sameAs": [
        "https://www.linkedin.com/in/regiane-f-a2a802ab",
        "https://www.instagram.com/engregianefialho/"
      ]
    });
    document.head.appendChild(orgScript);

    // Add WebSite Schema
    const websiteScript = document.createElement('script');
    websiteScript.type = 'application/ld+json';
    websiteScript.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Regiane Fialho - Engenharia Civil",
      "url": import.meta.env.VITE_SITE_URL || "https://regianefialho.com.br",
      "description": "Engenharia orientada a resultados em Maringá/PR: PPCP, Projetos & Obras e Segurança do Trabalho.",
      "publisher": {
        "@type": "Organization",
        "name": "Regiane Fialho - Engenharia Civil"
      },
      "potentialAction": {
        "@type": "SearchAction",
        "target": `${import.meta.env.VITE_SITE_URL || "https://regianefialho.com.br"}/?q={search_term_string}`,
        "query-input": "required name=search_term_string"
      }
    });
    document.head.appendChild(websiteScript);

    return () => {
      // Cleanup scripts when component unmounts
      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      scripts.forEach(script => script.remove());
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <ExperienceSection />
        <SkillsSection />
        <TestimonialsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
